import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

export function useAppLogout() {
  const { logout, isAuthenticated } = useAuth0();

  return useCallback(
    (navigate: any) => {
      if (isAuthenticated) {
        logout({ logoutParams: { returnTo: window.location.origin } });
      } else {
        // Nowcerts or fallback logout
        localStorage.clear();
        navigate("/");
      }
    },
    [logout, isAuthenticated]
  );
} 